var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.initialized)?[_c('the-header'),_c('v-main',[_c('router-view')],1)]:(_vm.loading)?[_c('loading-layout')]:[_c('error-layout',{attrs:{"error":_vm.$t('views.main.error.title'),"message":_vm.$t('views.main.error.message')}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }